import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { DateTime } from "luxon";
import CONFIG from "./config";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./components/ui/Tabs";
import TimePicker from 'react-time-picker';
axios.defaults.withCredentials = true;


const convertToBusinessTimezone = (utcTime, businessTimezone) => {
    return DateTime.fromISO(utcTime, { zone: "UTC" }).setZone(businessTimezone).toFormat("yyyy-MM-dd HH:mm");
};

// Helper function to calculate the next half-hour increment
const getNextHalfHourInBusinessTime = (businessTimezone) => {
    const now = DateTime.now().setZone(businessTimezone); // Get current time in business timezone
    const minutes = now.minute;
    const roundedMinutes = minutes + (30 - (minutes % 30)) % 30; // Round to next half-hour

    return now.set({ minute: roundedMinutes, second: 0, millisecond: 0 }).toFormat("HH:mm"); // Format as HH:mm
};

const Dashboard = () => {
    const [redirectError, setRedirectError] = useState("");
    const [redirectSuccess, setRedirectSuccess] = useState("");
     // Handle redirect uccess or failure messages
    useEffect(() => {
            const queryParams = new URLSearchParams(window.location.search);
            const errorParam = queryParams.get("error");
            const successParam = queryParams.get("success");
          
            if (errorParam) {
              setRedirectError(errorParam);
            }
            if (successParam) {
              setRedirectSuccess(successParam);
            }

            // Remove the query parameters from the URL without reloading the page
            const newUrl = window.location.pathname;
            window.history.replaceState(null, "", newUrl);
          }, []);   
    
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const editEventRef = useRef(null);
    const [profile, setProfile] = useState({
        name: "",
        description: "",
        business_id: "",
        business_address: "",  // Added field
        business_phone: "",    // Added field
        business_email: "",    // Added field
        services: [],
        timezone: null,
        bookable_days: 30,
        booking_interval: 15,
        hours_advance: 0,
        published: false,
        req_cus_info: { name: true, email: true, phone: false, address: false }, // New JSONB field
        ol_link: "",
        rili_coins: 0,
        tier: "free",
    });
    
    const [published, setPublished] = useState(false);
    const [auto_confirm, setAuto_confirm] = useState(false);
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [newEvent, setNewEvent] = useState({
        title: "",
        start_time: DateTime.now().plus({ hours: 1 }).toFormat("yyyy-MM-dd'T'HH:mm"),
        end_time: DateTime.now().plus({ hours: 2 }).toFormat("yyyy-MM-dd'T'HH:mm"),
        customerName: "",
        customerAddress: "",
        customerEmail: "",
        customerPhone: "",
        services: "",
        service_id: null,
        ol_link: ""
    });
    const [workingHours, setWorkingHours] = useState([
        { day_of_week: "Monday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: true },
        { day_of_week: "Tuesday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: true },
        { day_of_week: "Wednesday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: true },
        { day_of_week: "Thursday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: true },
        { day_of_week: "Friday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: true },
        { day_of_week: "Saturday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: false },
        { day_of_week: "Sunday", morning_start_time: "09:00", morning_end_time: "17:00", afternoon_start_time: "17:00", afternoon_end_time: "17:00", enabled: false },
    ]);    
    const [newService, setNewService] = useState({ 
        name: "", 
        duration: "",
        price: "",
        capacity: "",
        description: "",
    });
    const [editedService, setEditedService] = useState({
        service_id: "",
        name: "",
        duration: "",
        capacity: "",
        price: "",
        description: "",
    });
    const [services, setServices] = useState([]);
    const [error, setError] = useState("");
    const [eventError, setEventError] = useState("");
    const [eventMessage, setEventMessage] = useState("");
    const [profileError, setProfileError] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const navigate = useNavigate();

    const [serviceRequests, setServiceRequests] = useState([]);
    const selectedEventRef = useRef(null);
    const [showCreateEventForm, setShowCreateEventForm] = useState(false);
    const toggleCreateEventForm = () => {
        if (profile.business_id) {
            setShowCreateEventForm(!showCreateEventForm);
            setEventError("");
            setEventMessage("");
            setSelectedEvent(null);
            setSelectedDate(DateTime.now().toJSDate());
            initializeServiceAndAvailability();
            if (!showCreateEventForm) {
                // Reset only the time fields when opening the form
                setNewEvent((prevEvent) => ({
                    ...prevEvent,
                    start_time: DateTime.now().plus({ hours: 1 }).toFormat("yyyy-MM-dd'T'HH:mm"),
                    end_time: DateTime.now().plus({ hours: 2 }).toFormat("yyyy-MM-dd'T'HH:mm"),
                }));
            }
        } else {
            alert("Please set Business ID in the Business Page tab first.");
            return;
        }
        
    };
    
    const [bookableDays, setBookableDays] = useState(30); // Default to 30 days
    const [bookingInterval, setBookingInterval] = useState(15); // Default to 15 minutes
    const [hoursAdvance, setHoursAdvance] = useState(0); // Default to 0 hours
    const [reqCusInfo, setReqCusInfo] = useState({ name: true, email: true, phone: false, address: false });
    const [notifyOwner, setNotifyOwner] = useState(false);
    const [notifyCustomer, setNotifyCustomer] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [originalEvent, setOriginalEvent] = useState(null);
    const [showRiliCoins, setShowRiliCoins] = useState(false);
    const [showTier, setShowTier] = useState(false);
    const [availableDates, setAvailableDates] = useState([]);
    const [availability, setAvailability] = useState({});
    const [selectedDate, setSelectedDate] = useState(DateTime.now().toJSDate());
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const bookingSectionRef = useRef(null);
    const riliCoinsRef = useRef(null);
    const tierRef = useRef(null);
    const topSectionRiliCoinsRef = useRef(null);
    const topSectionTierRef = useRef(null);
    const calendarRef = useRef(null);  // Add this line near other refs
    const [showAddService, setShowAddService] = useState(false);
    const [showEditService, setShowEditService] = useState(false);
    const [showAddShift, setShowAddShift] = useState(false);
    const [showEditShift, setShowEditShift] = useState(false);
    const [newShift, setNewShift] = useState({
        day_of_week: '',
        shift_start_time: '09:00',
        shift_end_time: '17:00',
        bookable_services: []
    });
    const [editedShift, setEditedShift] = useState(null);
    const [businessHours, setBusinessHours] = useState([]);
    const businessHourRef = useRef(null);  // Change to useRef instead of useState
    const [showBusinessHours, setShowBusinessHours] = useState(false);
    const [shiftError, setShiftError] = useState("");

    // Add this near the top of your component with other state declarations
    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    // Add this useEffect to handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showRiliCoins && riliCoinsRef.current && topSectionRiliCoinsRef.current && !riliCoinsRef.current.contains(event.target) && !topSectionRiliCoinsRef.current.contains(event.target)) {
                setShowRiliCoins(false);
                setShowTier(false);
            }

            if (showTier && tierRef.current && topSectionTierRef.current && !tierRef.current.contains(event.target) && !topSectionTierRef.current.contains(event.target)) {
                setShowTier(false);
                setShowRiliCoins(false);
            }

            if (selectedEvent && selectedEventRef.current && !selectedEventRef.current.contains(event.target)) {
                setSelectedEvent(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showRiliCoins, showTier, selectedEvent]);

    useEffect(() => {
        fetchServiceRequests();
    }, []);

    const fetchServiceRequests = async () => {
        try {
            const response = await axios.get(`${CONFIG.BACKEND_URL}/api/service-requests`);
            setServiceRequests(response.data); // Update state with the fetched requests
        } catch (err) {
            console.error("Error fetching service requests:", err);
            setError("Failed to fetch service requests.");
            navigate("/"); // Redirect to login page if unauthorized
        }
    };
    
    useEffect(() => {
        fetchProfile();
        fetchUserEmail();
        fetchWorkingHours(); // Fetch working hours   
        fetchServices();
    }, []);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + CONFIG.siteKey;
        script.async = true;
        document.body.appendChild(script);
        return () => {
          document.body.removeChild(script);
        };
      }, []);

    useEffect(() => {
        if (profile.timezone) {
            // Set event date and time in the business timezone
            setNewEvent((prevEvent) => ({
                ...prevEvent,
                start_time: DateTime.now().setZone(profile.timezone).toFormat("yyyy-MM-dd'T'HH:mm"),
                end_time: DateTime.now().setZone(profile.timezone).plus({ hours: 1 }).toFormat("yyyy-MM-dd'T'HH:mm"),
            }));
        }
    }, [profile.timezone]);

    const [tempBusinessId, setTempBusinessId] = useState("");

    // Update tempBusinessId only if business_id is NOT empty
    useEffect(() => {
        if (profile.business_id) {
            setTempBusinessId(profile.business_id);
        } 
    }, [profile.business_id]);


    const handleChangePassword = async () => {
        if (!currentPassword || !newPassword || !confirmNewPassword) {
            setPasswordError("All fields are required.");
            return;
        }
        if (newPassword !== confirmNewPassword) {
            setPasswordError("New passwords do not match.");
            return;
        }
        if (newPassword.length < 6) {
            setPasswordError("Password must be at least 6 characters.");
            return;
        }
    
        try {
            const response = await axios.post(
                `${CONFIG.BACKEND_URL}/api/change-password`,
                {
                    currentPassword,
                    newPassword,
                }
            );
    
            alert(response.data.message);
            setShowChangePassword(false);
            setCurrentPassword("");
            setNewPassword("");
            setConfirmNewPassword("");
            setPasswordError("");
        } catch (err) {
            setPasswordError(err.response?.data?.error || "Password change failed.");
        }
    };
    
    

    const fetchProfile = async () => {
        try {
            const response = await axios.get(`${CONFIG.BACKEND_URL}/api/profile`);
    
            const profile = response.data || {
                name: "",
                description: "",
                business_id: "",
                business_address: "",
                business_phone: "",
                services: [],
                published: false,
                timezone: null,
                bookable_days: 30,
                booking_interval: 15,
                hours_advance: 0,
                business_email: "",
                req_cus_info: { name: false, email: true, phone: false, address: false }, // Default
                auto_confirm: false,
                ol_link: "",
                notify_owner: false,
                notify_customer: false,
                rili_coins: 0,
                tier: "free",
            };
    
            setProfile(profile);
            setBookableDays(profile.bookable_days || 30);
            setBookingInterval(profile.booking_interval || 15);
            setHoursAdvance(profile.hours_advance || 0);
            setReqCusInfo(profile.req_cus_info || { name: true, email: true, phone: false, address: false }); // Set required fields
            setPublished(profile.published || false);
            setAuto_confirm(profile.auto_confirm || false);
            setNotifyOwner(profile.notify_owner || false);
            setNotifyCustomer(profile.notify_customer || false);
        } catch (err) {
            console.error("Failed to fetch profile:", err.response || err.message);
            setError("Failed to fetch profile.");
        }
    };

    const fetchAvailability = async (duration = 30, serviceId = null) => {
        try {
            const response = await axios.get(
                `${CONFIG.BACKEND_URL}/api/availability/${profile.business_id}`,
                { params: { duration, service_id: serviceId } }
            );
    
            const rawAvailability = response.data.availability || {};
            const businessTimezone = profile?.timezone || "UTC";
    
            // Extract available dates for calendar view
            const availableDates = Object.keys(rawAvailability).filter(
                (date) => rawAvailability[date].length > 0
            );
    
            // Store both availableDates and rawAvailability
            setAvailability(rawAvailability); // Used for slots
            setAvailableDates(availableDates.map((date) => 
                DateTime.fromISO(date, { zone: businessTimezone }).toISODate()
            )); // Update calendar view
    
            return { rawAvailability, availableDates };
        } catch (err) {
            console.error("Error fetching availability:", err);
            setError("Failed to fetch availability.");
            return { rawAvailability: {}, availableDates: [] };
        }
    };

    const handleDateClick = async (info) => {
        const businessTimezone = profile?.timezone || "UTC";
    
        const clickedDate = DateTime.fromFormat(info.dateStr, "yyyy-MM-dd", { zone: businessTimezone }).toISODate();
    
        try {
            const duration = selectedService?.duration || 30;
            const { rawAvailability } = await fetchAvailability(duration, selectedService.service_id);
    
    
            const rawSlots = rawAvailability[clickedDate] || [];
    
            const convertedSlots = rawSlots.map((utcSlot) =>
                DateTime.fromISO(utcSlot, { zone: "UTC" }).setZone(businessTimezone).toISO()
            );

            // ✅ Properly handle empty slots before setting selectedDate
            if (convertedSlots.length > 0 && convertedSlots[0]) {
                setSelectedDate(DateTime.fromISO(convertedSlots[0], { zone: businessTimezone }).toJSDate());
                const initialSlot = convertedSlots[0];
                const endTime = DateTime.fromISO(initialSlot).plus({ minutes: selectedService.duration }).toISO();
                setNewEvent({ ...newEvent, start_time: initialSlot, end_time: endTime});
            } else {
                setSelectedDate(DateTime.fromFormat(clickedDate, "yyyy-MM-dd", { zone: businessTimezone }).toJSDate());
                const initialSlot = DateTime.fromISO(clickedDate, { zone: businessTimezone }).plus({ hours: 9 }).toISO();
                const endTime = DateTime.fromISO(initialSlot).plus({ minutes: selectedService.duration }).toISO();
                setNewEvent({ ...newEvent, start_time: initialSlot, end_time: endTime});
            }

            setAvailableSlots(convertedSlots);

            // Defer scrolling until DOM updates
            setTimeout(() => {
                if (bookingSectionRef.current) {
                bookingSectionRef.current.scrollIntoView({ behavior: "smooth" });
                }
            }, 0);

            // ✅ Auto-scroll to the booking section
            if (bookingSectionRef.current) {
                bookingSectionRef.current.scrollIntoView({ behavior: "smooth" });
            }
        } catch (err) {
            console.error("❌ Error fetching slots for date click:", err);
            setError("Failed to fetch available slots for the selected date.");
        }
    };

    
    
    const handleServiceChange = async (service) => {
    
        setSelectedService(service);
    
        if (service) {
            try {
                const { rawAvailability } = await fetchAvailability(service.duration, service.service_id);
    
                if (selectedDate) {
                    const businessTimezone = profile?.timezone || "UTC";
    
                    // Convert selected date to business timezone format
                    const dateKey = DateTime.fromJSDate(selectedDate, { zone: businessTimezone }).toISODate();
    
                    // Get available slots and convert them to business timezone
                    const updatedSlots = (rawAvailability[dateKey] || []).map(slot =>
                        DateTime.fromISO(slot, { zone: "UTC" }).setZone(businessTimezone).toISO()
                    );
    
                    setAvailableSlots(updatedSlots);
                    setNewEvent({ ...newEvent, service_id: service.service_id });

                    // ✅ Properly handle empty slots before setting selectedDate
                    if (updatedSlots.length > 0 && updatedSlots[0]) {
                        setSelectedDate(DateTime.fromISO(updatedSlots[0], { zone: profile?.timezone || "UTC" }).toJSDate());
                    } 
                    setError(updatedSlots.length === 0 ? "No available slots for this service." : "");
                }
            } catch (err) {
                console.error("❌ Error updating availability for selected service:", err);
                setError("Failed to update availability based on the selected service.");
            }
        }
    };
    
    

    const togglePublishStatus = async () => {
        try {
            const response = await axios.post(
                `${CONFIG.BACKEND_URL}/api/profile/publish`,
                { published: !published }
            );
            setPublished(response.data.published);
            alert(`Business page ${response.data.published ? "published" : "unpublished"} successfully.`);
        } catch (err) {
            console.error("Failed to update publish status:", err);
        }
    };
    
    
    const saveProfile = async () => {
        if (!profile.name) {
            setProfileError('Business Name is required');
            return;
          }
        try {
            await axios.post(
                `${CONFIG.BACKEND_URL}/api/profile`,
                { 
                    name: profile.name, 
                    description: profile.description, 
                    business_id: profile.business_id,
                    timezone: profile.timezone,
                    business_address: profile.business_address,
                    business_phone: profile.business_phone,
                    business_email:profile.business_email,
                    ol_link: profile.ol_link,
                }
            );
    
            alert("Profile saved successfully!");
        } catch (err) {
            console.error("Save profile error:", err.response?.data || err.message);
    
            if (err.response && err.response.status === 400 && err.response.data.error) {
                alert(`Failed to save profile: ${err.response.data.error}`);
            } else {
                alert("Failed to save profile. Please try again.");
            }
        }
    };
    
       
    

    const fetchEvents = async (start, end) => {
        try {
            const response = await axios.get(`${CONFIG.BACKEND_URL}/api/calendar`, { params: { start, end } });
    
            const timezone = profile.timezone || "UTC"; // Default to UTC if no timezone
            const convertedEvents = response.data.map((event) => ({
                ...event,
                start: convertToBusinessTimezone(event.start_time, timezone),
                end: convertToBusinessTimezone(event.end_time, timezone),
            }));
    
            setEvents(convertedEvents);
        } catch (err) {
            setError("Failed to fetch events.");
        }
    };
    

    const fetchUserEmail = async () => {
        try {
            const response = await axios.get(`${CONFIG.BACKEND_URL}/api/user`);
            setUserEmail(response.data.email);
        } catch (err) {
            console.error("Failed to fetch user email:", err.response || err.message);
        }
    };

    const handleEventClick = (info) => {
        const clickedEvent = events.find((event) => event.id === parseInt(info.event.id, 10));
        setEventError("");
        setEventMessage("");
        setShowCreateEventForm(false);
    
        if (clickedEvent) {
            setSelectedEvent({
                ...clickedEvent,
                start_time: DateTime.fromISO(clickedEvent.start_time, { zone: "UTC" }) // Convert to business timezone
                    .setZone(profile.timezone || "UTC")
                    .toISO(),
                end_time: DateTime.fromISO(clickedEvent.end_time, { zone: "UTC" })
                    .setZone(profile.timezone || "UTC")
                    .toISO(),
                    customer_name: clickedEvent.customer_name || "",
                    customer_address: clickedEvent.customer_address || "",
                    customer_email: clickedEvent.customer_email || "",
                    customer_phone: clickedEvent.customer_phone || "",
                    services: clickedEvent.services || "",
            });
            
            setOriginalEvent({
                ...clickedEvent,
                start_time: DateTime.fromISO(clickedEvent.start_time, { zone: "UTC" }) // Convert to business timezone
                    .setZone(profile.timezone || "UTC")
                    .toISO(),
                end_time: DateTime.fromISO(clickedEvent.end_time, { zone: "UTC" })
                    .setZone(profile.timezone || "UTC")
                    .toISO(),
                    customer_name: clickedEvent.customer_name || "",
                    customer_address: clickedEvent.customer_address || "",
                    customer_email: clickedEvent.customer_email || "",
                    customer_phone: clickedEvent.customer_phone || "",
                    services: clickedEvent.services || "",
            });
            setIsEditing(false);
            // ⬇️ Scroll smoothly to the edit event section
            setTimeout(() => {
                if (editEventRef.current) {
                    editEventRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        }
    };
    

    const handleNewEventChange = (e) => {
        const { name, value } = e.target;
        setNewEvent({ ...newEvent, [name]: value });
    };

    const handleStartTimeChange = (e) => {
        const newStartTime = e.target.value;
        const newEndTime = DateTime.fromISO(newStartTime).plus({ hours: 1 }).toFormat("yyyy-MM-dd'T'HH:mm");
        setNewEvent({
            ...newEvent,
            start_time: newStartTime,
            end_time: newEndTime
        });
    };

    const handleEndTimeChange = (e) => {
        const newEndTime = e.target.value;
        if (DateTime.fromISO(newEndTime) > DateTime.fromISO(newEvent.start_time)) {
            setNewEvent({ ...newEvent, end_time: newEndTime });
        } else {
            alert("End time must be later than start time.");
        }
    };

    const createEvent = async () => {
        setEventError("");
        setEventMessage("");

        if (!newEvent.title) {
            setEventError("Event Title is required.");
            return;
        }

        try {
            const startDateTime = DateTime.fromISO(newEvent.start_time);
            const endDateTime = DateTime.fromISO(newEvent.end_time);

            if (startDateTime < DateTime.now()) {
                setEventError("Cannot create an event in the past.");
                return;
            }

            if (endDateTime <= startDateTime) {
                setEventError("End time must be later than start time.");
                return;
            }

            const token = await window.grecaptcha.enterprise.execute(CONFIG.siteKey, { action: 'submit' });

            const response = await axios.post(
                `${CONFIG.BACKEND_URL}/api/calendar`,
                {
                    ...newEvent,
                    start_time: startDateTime.toUTC().toISO(),
                    end_time: endDateTime.toUTC().toISO(),
                    recaptchaToken: token,
                    action: "submit",
                }
            );

            // Get the current calendar view's date range using the ref
            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();
                const view = calendarApi.view;
                fetchEvents(view.activeStart, view.activeEnd);
            }

            setEventMessage(response.data.message || "Event created successfully!");
            setShowCreateEventForm(false);
            setNewEvent({
                title: "",
                start_time: DateTime.now().plus({ hours: 1 }).toFormat("yyyy-MM-dd'T'HH:mm"),
                end_time: DateTime.now().plus({ hours: 2 }).toFormat("yyyy-MM-dd'T'HH:mm"),
                customerName: "",
                customerAddress: "",
                customerEmail: "",
                customerPhone: "",
                services: "",
                service_id: null,
                ol_link: ""
            });
        } catch (err) {
            console.error("Failed to create event:", err.response || err.message);
            if (err.response && err.response.status === 400) {
                const errorMessage = err.response.data.error || "Failed to create event!";
                setEventError(errorMessage);
            } else {
                setEventError("Failed to create event.");
            }
        }
    };    

    const updateEvent = async (event) => {
        setEventError("");
        setEventMessage("");
        try {
            if (event.ol_link === profile.ol_link) {
                event.ol_link = ""; // Set to empty if they are the same
            }
            const { start_time, end_time } = event;
            const startDateTime = DateTime.fromISO(start_time);
            // Validate that end_time is after start_time
            if (new Date(end_time) <= new Date(start_time)) {
                setEventError("End time must be after start time.");
                return;
            }

            const token = await window.grecaptcha.enterprise.execute(CONFIG.siteKey, { action: 'submit' });
    
            const response = await axios.put(
                `${CONFIG.BACKEND_URL}/api/calendar/${event.id}`,
                {
                    ...event,
                    start_time,
                    end_time,
                    additional_info: event.additional_info || "",
                    recaptchaToken: token,
                    action: "submit",
                }
            );
            // Get the current calendar view's date range using the ref
            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();
                const view = calendarApi.view;
                fetchEvents(view.activeStart, view.activeEnd);
            }
            setEventMessage(response.data.message || "Event updated successfully!");    
            //setSelectedEvent(null); // Deselect the event after updating
            setIsEditing(false);
        } catch (err) {
            console.error("Failed to update event:", err.response || err.message);
            if (err.response && err.response.status === 400) {
                const errorMessage = err.response.data.error || "Failed to update event!";
                setEventError(errorMessage);
              } else {
                setEventError("Failed to update event.");
            }
        }
    };
    
    
    const deleteEvent = async (id) => {
        if (!window.confirm("Are you sure you want to delete this event?")) {
            return;
        }

        setEventError("");
        setEventMessage("");
    
        try {
            const response = await axios.delete(`${CONFIG.BACKEND_URL}/api/calendar/${id}`);
            // Get the current calendar view's date range using the ref
            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();
                const view = calendarApi.view;
                fetchEvents(view.activeStart, view.activeEnd);
            }
            setEventMessage(response.data.message || "Event deleted successfully!");
            setSelectedEvent(null); // Clear the selected event
        } catch (err) {
            console.error("Failed to delete event:", err.response || err.message);
            if (err.response && err.response.status === 400) {
                const errorMessage = err.response.data.error || "Failed to delete event.";
                setEventError(errorMessage);
              } else {
                setEventError("Failed to delete event.");
            }
        }
    };

    
    const fetchWorkingHours = async () => {
        try {
            const response = await fetch(`${CONFIG.BACKEND_URL}/api/business-hours`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Failed to fetch business hours');
            const data = await response.json();
            setBusinessHours(data);
        } catch (error) {
            console.error('Error fetching business hours:', error);
        }
    };

    const fetchServices = async () => {
        const response = await axios.get(`${CONFIG.BACKEND_URL}/api/services`);
        setServices(response.data.services || []);
    };
    
    const addService = async () => {
        if (!newService.name || !newService.duration) {
            alert("Please provide both service name and duration.");
            return;
        }
    
        // Check for duplicate service name
        const serviceExists = services.some(
            (service) => service.name.toLowerCase() === newService.name.toLowerCase()
        );
    
        if (serviceExists) {
            alert("Service name must be unique.");
            return;
        }
    
        const newServiceToAdd = { name: newService.name, duration: parseInt(newService.duration, 10), price: parseFloat(newService.price), capacity: parseInt(newService.capacity, 10), description: newService.description };
    
        try {
            const serviceResponse = await axios.post(
                `${CONFIG.BACKEND_URL}/api/service`,
                { service: newServiceToAdd }
            );
    
            setServices(serviceResponse.data.services || []);
            setNewService({ name: "", duration: "", capacity: "", price: "", description: "" });
            setShowAddService(false);
            fetchWorkingHours();
        } catch (err) {
            console.error("Failed to save service:", err.response || err.message);
            setError("Failed to add service.");
        }
    };

    const editService = async () => {
        if (!editedService.name || !editedService.duration) {
            alert("Please provide both service name and duration.");
            return;
        }
        const serviceExists = services.some(
            (service) => service.service_id !== editedService.service_id && 
                        service.name.toLowerCase() === editedService.name.toLowerCase()
        );
    
        if (serviceExists) {
            alert("Service name must be unique.");
            return;
        }
        const newServiceToEdit = { name: editedService.name, duration: parseInt(editedService.duration, 10), price: parseFloat(editedService.price), capacity: parseInt(editedService.capacity, 10), description: editedService.description };
        try {
            const response = await axios.put(
                `${CONFIG.BACKEND_URL}/api/service/${editedService.service_id}`,
                { service: newServiceToEdit }
            );  
            setServices(response.data.services || []);
            setEditedService({ name: "", duration: "", capacity: "", price: "", description: "" });
            setShowEditService(false);
        } catch (err) {
            console.error("Failed to edit service:", err.response || err.message);
            setError("Failed to edit service.");
        }
    };
    
    const removeService = async (service_id) => {
    
        try {
            const response = await axios.post(
                `${CONFIG.BACKEND_URL}/api/service/${service_id}`
            );
    
            setServices(response.data.services || []);
            alert("Service removed successfully!");
        } catch (err) {
            console.error("Failed to remove service:", err.response || err.message);
            setError("Failed to remove service.");
        }
    };


    const handleAcceptRequest = async (id) => {
        try {
            const acceptResponse = await axios.post(`${CONFIG.BACKEND_URL}/api/service-requests/${id}/accept`, null);
            alert(`✅ ${acceptResponse.data.message}`);
            fetchServiceRequests();
        } catch (err) {
            console.error("Failed to accept request:", err);
        }
    };
    
    const handleDeclineRequest = async (id) => {
        try {
            const declineResponse = await axios.post(`${CONFIG.BACKEND_URL}/api/service-requests/${id}/decline`, null);
            alert(`❌ ${declineResponse.data.message}`);
            fetchServiceRequests();
        } catch (err) {
            console.error("Failed to decline request:", err);
        }
    };
    

    // Save booking options
    const saveBookingOptions = async (auto_confirm, notifyOwner, notifyCustomer, bookableDays, bookingInterval, hoursAdvance, reqCusInfo) => {
        try {
            await axios.post(
                `${CONFIG.BACKEND_URL}/api/booking-options`,
                {
                    bookable_days: bookableDays,
                    booking_interval: bookingInterval,
                    hours_advance: hoursAdvance,
                    req_cus_info: reqCusInfo, // Send required fields
                    auto_confirm: auto_confirm,
                    notify_owner: notifyOwner,
                    notify_customer: notifyCustomer,
                }
            );
        } catch (err) {
            console.error("Failed to save booking options:", err);
            alert("Failed to save booking options.");
        }
    };
    
    const handleLogout = async () => {
        try {
            await axios.post(`${CONFIG.BACKEND_URL}/api/logout`, {}, {
                withCredentials: true,
            });
            navigate("/");
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    function handleCancelEdit() {
        // Revert changes
        setSelectedEvent({ ...originalEvent }); 
        setIsEditing(false);
    };

    function handleDateTimeChange(e, field) {
        // 1) Convert the user input from "datetime-local" to ISO
        const newValue = DateTime.fromFormat(
          e.target.value,
          "yyyy-MM-dd'T'HH:mm",
          { zone: profile.timezone || "UTC" }
        )
          .toUTC()
          .toISO();
      
        // If changing the START time, also recalc end time by preserving the original duration
        if (field === "start_time") {
          const oldStartMs = new Date(selectedEvent.start_time).getTime();
          const oldEndMs = new Date(selectedEvent.end_time).getTime();
          const durationMs = oldEndMs - oldStartMs; // original duration
      
          // Add the original duration to the newly selected start time
          const newEndTime = DateTime.fromISO(newValue)
            .plus({ milliseconds: durationMs })
            .toUTC()
            .toISO();
      
          // Update both start_time and end_time in state
          setSelectedEvent({
            ...selectedEvent,
            start_time: newValue,
            end_time: newEndTime,
          });
        } else {
          // If user changed only the end_time, just update it normally
          setSelectedEvent({ ...selectedEvent, [field]: newValue });
        }
      }
      
    const initializeServiceAndAvailability = async () => {

        
        if (services && services.length > 0) {
            // Find the service with the smallest duration
            const smallestDurationService = services.reduce((minService, currentService) => {
                return currentService.duration < minService.duration ? currentService : minService;
            });

            setSelectedService(smallestDurationService); // Set the initial service
            setNewEvent({ ...newEvent, services: smallestDurationService.name, service_id: smallestDurationService.service_id});

            // Fetch availability for the smallest duration
            await fetchAvailability(smallestDurationService.duration, smallestDurationService.service_id);
        } else {
            // Default fetch if no services are available
            await fetchAvailability(30, null);
            setSelectedService({name:"Not Set", duration: 60});
        }
    };

    function formatForInput(dateString) {
        if (!dateString) return "";
        return DateTime.fromISO(dateString, { zone: profile.timezone || "UTC" })
          .toFormat("yyyy-MM-dd'T'HH:mm");
    };
      
    function formatDateTime(dateString) {
        if (!dateString) return "";
        return DateTime.fromISO(dateString, { zone: profile.timezone || "UTC" })
          .toFormat("ff"); // e.g., 'Sep 22, 2023, 12:34 PM'
    };
      

    const handleServiceToggle = async (shiftId, serviceId) => {
        try {
            const shift = workingHours.find(s => s.id === shiftId);
            if (!shift) return;

            const updatedServices = shift.bookable_services.includes(serviceId)
                ? shift.bookable_services.filter(id => id !== serviceId)
                : [...shift.bookable_services, serviceId];

            const response = await fetch(`${CONFIG.BACKEND_URL}/api/business-hours/${shiftId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    shift_start_time: shift.shift_start_time,
                    shift_end_time: shift.shift_end_time,
                    bookable_services: updatedServices
                }),
                credentials: 'include'
            });

            if (!response.ok) throw new Error('Failed to update shift');
            await fetchWorkingHours();
        } catch (error) {
            console.error('Error updating shift:', error);
        }
    };

    const removeShift = async (shiftId) => {
        try {
            const response = await fetch(`${CONFIG.BACKEND_URL}/api/business-hours/${shiftId}`, {
                method: 'DELETE',
                credentials: 'include'
            });

            if (!response.ok) throw new Error('Failed to delete shift');
            await fetchWorkingHours();
        } catch (error) {
            console.error('Error deleting shift:', error);
        }
    };

    const addNewShift = async () => {
        try {
            if (!newShift.day_of_week) {
                setShiftError('Please select a day of the week');
                return;
            }

            const response = await fetch(`${CONFIG.BACKEND_URL}/api/business-hours`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newShift),
                credentials: 'include'
            });

            const data = await response.json();

            if (!response.ok) {
                setShiftError(data.error || 'Failed to add shift');
                return;
            }
            
            setShiftError(''); // Clear error on success
            setShowAddShift(false);
            setNewShift({
                day_of_week: '',
                shift_start_time: '09:00',
                shift_end_time: '17:00',
                bookable_services: []
            });
            await fetchWorkingHours(); // Refresh the shifts list
        } catch (error) {
            console.error('Error adding shift:', error);
            setShiftError('An unexpected error occurred. Please try again.');
        }
    };
    
    const editShift = async () => {
        try {
            if (!editedShift.day_of_week) {
                setShiftError('Please select a day of the week');
                return;
            }

            const response = await fetch(`${CONFIG.BACKEND_URL}/api/business-hours/${editedShift.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    shift_start_time: editedShift.shift_start_time,
                    shift_end_time: editedShift.shift_end_time,
                    bookable_services: editedShift.bookable_services
                }),
                credentials: 'include'
            });

            const data = await response.json();

            if (!response.ok) {
                setShiftError(data.error || 'Failed to update shift');
                return;
            }

            setShiftError(''); // Clear error on success
            setShowEditShift(false);
            setEditedShift(null);
            await fetchWorkingHours(); // Refresh the shifts list
        } catch (error) {
            console.error('Error updating shift:', error);
            setShiftError('An unexpected error occurred. Please try again.');
        }
    };
    
    // Add this near the top of your component with other state declarations
    const dayOrder = {
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6,
        'Sunday': 7
    };

    // Add this before the return statement
    const sortedBusinessHours = [...businessHours].sort((a, b) => {
        return dayOrder[a.day_of_week] - dayOrder[b.day_of_week];
    });

    // Add this helper function near the top of your component
    const formatTime = (timeString) => {
        if (!timeString) return '';
        const [hours, minutes] = timeString.split(':');
        const hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };

    return (
        <div>
            <div style={styles.container}>

                <div style={styles.topSection}>
                        <p style={styles.logo}>
                            <a href={`${CONFIG.FRONTEND_URL}/dashboard`} style={{ textDecoration: "none", color: "inherit" }}>
                            Rili Day</a>
                        </p>
                        <p style={{ marginTop: "5px" }}>
                            <a
                                style={{
                                    textDecoration: "none",
                                    color: "grey",
                                    marginRight: "30px",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setShowRiliCoins((prevState) => !prevState);
                                    setShowTier(false);
                                }}
                                ref={topSectionRiliCoinsRef}
                            >
                                💰 {profile.rili_coins}
                            </a>
                            <a
                                style={{
                                    textDecoration: "none",
                                    color: "grey",
                                    marginLeft: "3px",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setShowTier((prevState) => !prevState);
                                    setShowRiliCoins(false);
                                }}
                                ref={topSectionTierRef}

                            >
                                👤 {profile.tier}
                            </a>
                        </p>
                </div>
                {showRiliCoins && (
                    <div style={styles.accountSection} ref={riliCoinsRef}>
                            <p>
                                <strong>Rili Coins</strong>
                                <br />
                                <br />
                                You may use your Rili Coins to upgrade your account to a premium tier once it is available.
                                <br />
                                <br />
                                One Rili Coin can redeem for One Month of Premium Access.
                                <br />
                                <br />
                                You can earn Rili Coins by inviting your friends to use Rili Day.
                                <br />
                                <br />
                                Just share your referral code with your friends and when they sign up and <strong>accept the first booking</strong>, both of you will receive one Rili Coin.
                                <br />
                                <br />
                                <strong>Your Referral Code:</strong> {profile.business_id ||"Your Business ID"}
                            </p>
                    </div>
                )}
                {showTier && (
                    <div style={styles.accountSection} ref={tierRef}>
                        <p>
                            <strong>Free Tier</strong>
                            <br />
                            You have exclusive lifetime ad-free privilege because you registered before June 1, 2025.
                            <br />
                            <br />
                            <strong>Free tier limitations:</strong>
                            <br />
                            - 10 daily events manually added from the dashboard
                            <br />
                            - Dynamic ads shown on the public page
                            <br />
                            <br />
                            Free tier includes all existing features plus lots of upcoming features.
                            <br />
                            <br />
                            <strong>Upcoming Features for Free Tier:</strong>
                            <br />
                            - Sync with Google Calendar and Outlook
                            <br />
                            - Google Maps integration
                            <br />
                            - and more!
                            <br />
                            <br />
                            <strong>Features in Future Premium Tier:</strong>
                            <br />
                            - Ads free public page
                            <br />
                            - Advanced customer management
                            <br />
                            - Invoice generation
                            <br />
                            - Deposit required booking
                            <br />
                            - SMS verification and notification
                            <br />
                            - Photos display on the public page
                            <br />
                            - and more!
                        </p>
                    </div>
                )}
                {published ? (
                                        <></>
                                    ) : (
                                        <p style={{ color: "red", fontWeight: "bold", display: "block" }}>⚠️ Your page is not published yet. 
                                        <br />Go to Business Page tab to setup your public page.</p>
                        )}
                {redirectError && <p style={styles.error}>{redirectError}</p>}
                {redirectSuccess && <p style={styles.success}>{redirectSuccess}</p>}
                {/* Service Requests Section */}
                {serviceRequests.length > 0 && (
                <div style={styles.requestsSection}>
                    <h2>Service Requests</h2>
                    {serviceRequests.map((request) => (
                        <div key={request.id} style={styles.requestItem}>
                            <p><strong>Customer:</strong> {request.customer_name}</p>
                            <p><strong>Email:</strong> {request.customer_email}</p>
                            <p><strong>Phone:</strong> {request.customer_phone}</p>
                            <p><strong>Address:</strong> {request.customer_address}</p>
                            <p><strong>Service:</strong> {request.service_name}</p>
                            <p><strong>Duration:</strong> {request.service_duration} minutes</p>
                            <p><strong>Requested Time:</strong> {new Date(request.start_time).toLocaleString()}</p>
                            <p><strong>Additional Information:</strong> {request.additional_info}</p>
                            <p><strong>Status:</strong> {request.status}</p>
                            <button
                                onClick={() => handleAcceptRequest(request.id)}
                                style={styles.acceptButton}
                            >
                                Accept
                            </button>
                            <button
                                onClick={() => handleDeclineRequest(request.id)}
                                style={styles.declineButton}
                            >
                                Decline
                            </button>
                        </div>
                    ))}
                </div>
                )}

                {/* ✅ Tabs Section - Always include `TabsContent` inside `Tabs` */}
                <Tabs defaultValue="calendar">
                    <TabsList className="grid grid-cols-2">
                        <TabsTrigger value="calendar" >My Calendar</TabsTrigger>
                        <TabsTrigger value="setup">Business Page</TabsTrigger>
                    </TabsList>

                    {/* My Calendar Tab */}
                    <TabsContent value="calendar">
                        <div style={styles.calendarSection}>
                            <p style={{ fontSize: '12px', color: '#555', marginTop: '0px', marginLeft: '10px' }}>
                                Calendar Timezone: {window.Intl.DateTimeFormat().resolvedOptions().timeZone}
                            </p>
                            <FullCalendar
                                ref={calendarRef}  // Add this line
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                height="auto"
                                headerToolbar={{
                                    left: "prev,next today",
                                    center: "",
                                    right: "title"
                                }}
                                datesSet={(dateInfo) => {
                                    // This function will be called when:
                                    // - next/prev buttons are clicked
                                    // - today button is clicked
                                    // - the view is initially rendered
                                    
                                    
                                    // Your custom logic here
                                    fetchEvents(DateTime.fromISO(dateInfo.startStr), DateTime.fromISO(dateInfo.endStr));
                                }}
                                titleFormat={{ month: "long" }}  // ✅ Show only the month name (e.g., "February")
                                selectable={true}
                                nowIndicator={true}
                                dayHeaderFormat={{ weekday: 'narrow' }}
                                //eventResizableFromStart={true}
                                eventClick={handleEventClick}
                                events={events.map(event => ({
                                    id: event.id,
                                    title: event.title,
                                    start: DateTime.fromISO(event.start_time, { zone: "UTC" }).setZone(profile.timezone || "UTC").toISO(),
                                    end: DateTime.fromISO(event.end_time, { zone: "UTC" }).setZone(profile.timezone || "UTC").toISO(),
                                    backgroundColor: "rgba(14, 111, 1, 1)", // Override global color
                                    eventBackgroundColor: "rgba(14, 111, 1, 1)",
                                    display: "auto",
                                }))}
                            />
                        </div>

                        {/* Edit Event Section */}
                        {selectedEvent && (
                            <div ref={selectedEventRef}>
                                <div ref={(el) => {
                                    editEventRef.current = el;
                                }
                                } style={styles.profileSection}>

                                    <h2 style={styles.sectionTitle}>Selected Event Details</h2>
                                    <p style={{ fontSize: '12px', color: '#555', marginTop: '-20px' }}>
                                        Timezone: {profile.timezone}
                                    </p>

                                    {/* If isEditing = false, show read-only. Otherwise show editable fields. */}
                                    {!isEditing ? (
                                    <>
                                        {/* READ-ONLY VIEW */}
                                        <p><strong>Booking Ref:</strong> {selectedEvent.booking_ref}</p>
                                        <p><strong>Title:</strong> {selectedEvent.title}</p>
                                        <p><strong>Start Time:</strong> {formatDateTime(selectedEvent.start_time)} </p>
                                        <p><strong>End Time:</strong> {formatDateTime(selectedEvent.end_time)} </p>
                                        <p><strong>Customer Name:</strong> {selectedEvent.customer_name}</p>
                                        <p><strong>Customer Address:</strong> {selectedEvent.customer_address}</p>
                                        <p><strong>Customer Email:</strong> {selectedEvent.customer_email}</p>
                                        <p><strong>Customer Phone:</strong> {selectedEvent.customer_phone}</p>
                                        <p><strong>Services:</strong> {selectedEvent.services}</p>
                                        <p>
                                            <strong>Online Meeting Link: </strong> 
                                            <a 
                                                href={selectedEvent.ol_link ? selectedEvent.ol_link : profile.ol_link} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{ 
                                                    textDecoration: "none", 
                                                    color: "inherit",
                                                    display: "block", // Ensures the link takes up the full width of the container
                                                    wordWrap: "break-word", // Allows long words to be broken and wrap to the next line
                                                    whiteSpace: "normal", // Allows the text to wrap normally
                                                    maxWidth: "100%" // Ensures the link respects the width of the container
                                                }}
                                            >
                                                {selectedEvent.ol_link ? selectedEvent.ol_link : profile.ol_link}
                                            </a>
                                        </p>
                                        <p><strong>Additional Info:</strong> {selectedEvent.additional_info}</p>

                                        <button onClick={() => setIsEditing(true)} style={styles.button}>Edit</button>
                                        <button onClick={() => setSelectedEvent(null)} style={styles.deleteButton}>Close</button>
                                    </>
                                    ) : (
                                    <>
                                        {/* EDITABLE VIEW */}
                                        <label style={styles.label}>Title</label>
                                        <input
                                        type="text"
                                        value={selectedEvent.title || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, title: e.target.value })}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Start Time</label>
                                        <input
                                        type="datetime-local"
                                        value={formatForInput(selectedEvent.start_time)}
                                        onChange={(e) => handleDateTimeChange(e, "start_time")}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>End Time</label>
                                        <input
                                        type="datetime-local"
                                        value={formatForInput(selectedEvent.end_time)}
                                        onChange={(e) => handleDateTimeChange(e, "end_time")}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Customer Name</label>
                                        <input
                                        type="text"
                                        value={selectedEvent.customer_name || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, customer_name: e.target.value })}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Customer Address</label>
                                        <input
                                        type="text"
                                        value={selectedEvent.customer_address || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, customer_address: e.target.value })}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Customer Email</label>
                                        <input
                                        type="email"
                                        value={selectedEvent.customer_email || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, customer_email: e.target.value })}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Customer Phone</label>
                                        <input
                                        type="tel"
                                        value={selectedEvent.customer_phone || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, customer_phone: e.target.value.replace(/\D/g, "") })}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Services</label>
                                        <input
                                        type="text"
                                        value={selectedEvent.services || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, services: e.target.value })}
                                        style={styles.input}
                                        />

                                        <label style={styles.label}>Online Meeting Link</label>
                                        <input
                                        type="text"
                                        value={selectedEvent.ol_link || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, ol_link: e.target.value })}
                                        style={styles.input}
                                        />
                                        <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                            Leave it empty if you want to use the default link set in the "My Business Page" tab.
                                        </p>

                                        <label style={styles.label}>Additional Information</label>
                                        <textarea
                                        style={styles.input}
                                        value={selectedEvent.additional_info || ""}
                                        onChange={(e) => setSelectedEvent({ ...selectedEvent, additional_info: e.target.value })}
                                        />

                                        <button onClick={() => updateEvent(selectedEvent)} style={styles.button}>Save Changes</button>
                                        <button onClick={() => handleCancelEdit()} style={styles.button}>Cancel</button>
                                        <button onClick={() => deleteEvent(selectedEvent.id)} style={styles.deleteButton}>Delete Event</button>
                                    </>
                                    )}

                                    {/* Optionally show error or success messages */}
                                    {eventError && <p style={{ color: "red" }}>{eventError}</p>}
                                    {eventMessage && <p style={{ color: "green" }}>{eventMessage}</p>}
                                </div>
                            </div>
                        )}


                        {/* Create Event Section */}
                        {!showCreateEventForm && (
                        <button onClick={toggleCreateEventForm} style={styles.button}>
                                    {showCreateEventForm ? "Cancel" : "Create New Event"}
                        </button>)
                        }
                        
                        {showCreateEventForm && (
                                <div style={styles.profileSection}>
                                    <button onClick={toggleCreateEventForm} style={styles.deleteButton}>Close</button>
                                    <h2 style={styles.sectionTitle}>Create New Event</h2>

                                    {services && services.length > 0 && (
                                    <label style={styles.label}>Select a Service for faster event creation</label>)}
                                    {!services || services.length == 0 && (
                                    <label style={styles.label}>Add a Service in Business Page Tab (Optional)</label>)  
                                    }
                                    <select
                                        style={styles.input}
                                        value={selectedService ? selectedService.name : ""}
                                        onChange={(e) => {
                                            const selectedServiceName = e.target.value;

                                            if (selectedServiceName === "Custom") {
                                                setSelectedService({ name: "Custom", duration: 60});
                                                handleServiceChange({ name: "Custom", duration: 60});
                                                setNewEvent({ ...newEvent, services: "" });
                                                return;
                                            }

                                            if (selectedServiceName) {
                                                const service = services.find(service => service.name === selectedServiceName);
                                                if (service) {
                                                    setSelectedService(service);
                                                    setNewEvent({ ...newEvent, services: service.name, service_id: service.service_id });
                                                    handleServiceChange(service); // Manually trigger handleServiceChange
                                                }
                                            } else {
                                                console.log("⚠️ No service selected");
                                            }
                                        }}
                                    >
                                        {services.map((service, index) => (
                                            <option key={index} value={service.name}>
                                                {service.name} - {service.duration} minutes
                                            </option>
                                        ))}
                                        <option value="Custom">Custom</option> {/* Custom option */}
                                    </select>

                                    <div style={styles.inputGroup}>

                                    <p style={styles.label}>Select a date for the new event </p>
                                    <p>
                                            The
                                            <span style={styles.colorBlock}>  
                                            </span> 
                                            blocks show the available dates for the selected service according to your business hours.
                                    </p>
                                    </div>

                                    <div style={styles.calendarSection2} ref={bookingSectionRef}>
                                       
                                        <FullCalendar
                                            plugins={[dayGridPlugin, interactionPlugin]}
                                            initialView="dayGridMonth"
                                            height="auto"
                                            headerToolbar={{
                                                left: "prev,next today",
                                                center: "",
                                                right: "title"
                                            }}
                                            titleFormat={{ month: "long" }}  // ✅ Show only the month name (e.g., "February")
                                            dayHeaderFormat={{ weekday: 'narrow' }}
                                            dayMaxEventRows={1}
                                            events={availableDates.map((date) => ({
                                                title: "",
                                                start: date, // Only date (no time)
                                                display: "background",
                                            }))}
                                            dateClick={handleDateClick}
                                        />
                                    </div>

                                    <div style={styles.inputGroup} >
                                    <label style={styles.label}>
                                        Available Slots on{" "}
                                        {selectedDate.toLocaleDateString([], {
                                            weekday: "long",
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                        })}
                                        
                                    </label>
                                    <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                        Timezone: {profile?.timezone}
                                    </p>
                                    
                                    {availableSlots.length > 0 ? (
                                        <select
                                            style={styles.input}
                                            value={selectedDate ? DateTime.fromJSDate(selectedDate).toISO() : ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value) {
                                                    // Convert selected slot to a JavaScript Date in the business timezone
                                                    const selectedSlot1 = DateTime.fromISO(value, { zone: profile?.timezone || "UTC" }).toJSDate();
                                                    const selectedSlot = DateTime.fromISO(value, { zone: "UTC" }) 
                                                    .setZone(profile.timezone || "UTC")
                                                    .toISO();
                                                    const endTime = DateTime.fromISO(value, { zone: "UTC" }) 
                                                    .setZone(profile.timezone || "UTC")
                                                    .plus({ minutes: selectedService.duration })
                                                    .toISO();
                                                    setNewEvent({ ...newEvent, start_time: selectedSlot, end_time: endTime});
                                                    setSelectedDate(selectedSlot1); // Update selected date

                                                } else {
                                                    console.log("⚠️ No slot selected.");
                                                }
                                            }}
                                        >
                                            {availableSlots.map((slot, index) => (
                                                <option key={index} value={slot}>
                                                    {DateTime.fromISO(slot, { zone: profile?.timezone || "UTC" }).toFormat("hh:mm a")}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <p>No available slots for this date according to your business hours and availability. <br />
                                        You may manually set the time in the next steps to create an event, <br />
                                        but it may overlap with other events.</p>
                                    )}
                                    </div>

                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Event Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Required"
                                        value={newEvent.title}
                                        onChange={handleNewEventChange}
                                        style={styles.input}
                                    />
                                    </div>
                                    
                                    {selectedService.name === "Custom" && (
                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Start Time</label>
                                    <input
                                        type="datetime-local"
                                        name="start_time"
                                        value={formatForInput(newEvent.start_time)}
                                        onChange={handleStartTimeChange}
                                        style={styles.input}
                                    />
                                    </div>
                                    )}

                                    {selectedService.name === "Custom" && (
                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>End Time</label>
                                    <input
                                        type="datetime-local"
                                        name="end_time"
                                        value={formatForInput(newEvent.end_time)}
                                        onChange={handleEndTimeChange}
                                        style={styles.input}
                                    />
                                    </div>
                                    )}

                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Customer Name</label>
                                    <input
                                        type="text"
                                        name="customerName"
                                        placeholder="Optional"
                                        value={newEvent.customerName}
                                        onChange={handleNewEventChange}
                                        style={styles.input}
                                    />
                                    </div>

                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Customer Address</label>
                                    <input
                                        type="text"
                                        name="customerAddress"
                                        placeholder="Optional"
                                        value={newEvent.customerAddress}
                                        onChange={handleNewEventChange}
                                        style={styles.input}
                                    />
                                    </div>

                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Customer Email</label>
                                    <input
                                        type="email"
                                        name="customerEmail"
                                        placeholder="Optional"
                                        value={newEvent.customerEmail}
                                        onChange={handleNewEventChange}
                                        style={styles.input}
                                    />
                                    </div>

                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Customer Phone</label>
                                    <input
                                        type="tel"
                                        name="customerPhone"
                                        placeholder="Optional"
                                        value={newEvent.customerPhone}
                                        onChange={(e) =>
                                            setNewEvent({
                                                ...newEvent,
                                                customerPhone: e.target.value.replace(/\D/g, ""), // Remove all non-numeric characters
                                                })
                                            }
                                            style={styles.input}
                                        />
                                    </div>

                                    {selectedService.name === "Custom" && (
                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Services Required</label>
                                    <input
                                        type="text"
                                        name="services"
                                        placeholder="Optional"
                                        value={newEvent.services}
                                        onChange={handleNewEventChange}
                                        style={styles.input}
                                    />
                                    </div>
                                    )}

                                    <div style={styles.inputGroup}>
                                    <label style={styles.label}>Online Meeting Link</label>
                                    <input
                                        type="text"
                                        name="ol_link"
                                        placeholder="Optional"
                                        value={newEvent.ol_link}
                                        onChange={handleNewEventChange}
                                        style={styles.input}
                                    />
                                    <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                        Leave it empty if you want to use the default link set in the "My Business Page" tab.
                                    </p>
                                    </div>

                                    <button onClick={createEvent} style={styles.button}>Create Event</button>
                                    <button onClick={toggleCreateEventForm} style={styles.deleteButton}>Close</button>
                                    {eventError && <p style={{ color: "red" }}>{eventError}</p>}
                                    
                        </div>
                        )}
                        {eventMessage && !selectedEvent && <p style={{ color: "green" }}>{eventMessage}</p>}

                    </TabsContent>

                    {/* Setup My Business Page Tab */}
                    <TabsContent value="setup">
                        
                        <div style={styles.profileSection}>
                        {published ? (
                                        <>
                                            <p style={{ color: "green", fontWeight: "bold" }}>✅ Your page is published!</p>
                                            <p>Your public page is:  <br />
                                                <a href={`/${profile.business_id}`} target="_blank" rel="noopener noreferrer">
                                                    {window.location.origin}/{profile.business_id}
                                                </a>
                                            </p>
                                        </>
                                    ) : (
                                        <p style={{ color: "red", fontWeight: "bold" }}>Complete your business info and publish at the end of this page.</p>
                        )}
                            <h2 style={styles.sectionTitle}>Business Profile</h2>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Business Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter your business name"
                                    value={profile.name}
                                    onChange={(e) => setProfile({ ...profile, name: e.target.value })}
                                    style={styles.input}
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Business Description</label>
                                <textarea 
                                    placeholder="Describe your business"
                                    value={profile.description}
                                    onChange={(e) => setProfile({ ...profile, description: e.target.value })}
                                    style={styles.textarea}
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Business Email</label>
                                <input
                                    type="text"
                                    placeholder="Optional"
                                    value={profile.business_email}
                                    onChange={(e) => setProfile({ ...profile, business_email: e.target.value })}
                                    style={styles.input}
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Business Address</label>
                                <input
                                    type="text"
                                    placeholder="Optional"
                                    value={profile.business_address}
                                    onChange={(e) => setProfile({ ...profile, business_address: e.target.value })}
                                    style={styles.input}
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Business Phone</label>
                                <input
                                    type="tel"
                                    placeholder="Optional"
                                    value={profile.business_phone}
                                    onChange={(e) => setProfile({ ...profile, business_phone: e.target.value })}
                                    style={styles.input}
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Online Meeting Link</label>
                                <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                Only required if all of your appointments are conducted online.
                                <br />
                                Once set, this link will be included in your booking confirmation email by default.
                                <br />
                                If you need a separate link for a specific event, you can update it by clicking the "Edit" button for that event.
                                </p>
                                <input
                                    type="text"
                                    placeholder="Optional"
                                    value={profile.ol_link}
                                    onChange={(e) => setProfile({ ...profile, ol_link: e.target.value })}
                                    style={styles.input}
                                />
                                
                            </div>

                            <button onClick={saveProfile} style={styles.button}>Save Profile</button>
                            {profileError && <p style={styles.error}>{profileError}</p>}
                        </div>

                        <div style={styles.businessHoursSection} ref={businessHourRef}>
                            <button onClick={() => setShowBusinessHours(!showBusinessHours)} style={{...styles.button, marginBottom: '10px'}}>
                                {showBusinessHours ? 'Hide Business Hours' : 'Set Business Hours'}
                            </button>
                            {showBusinessHours && (
                                <>
                

                            {showAddShift ? (
                                <div style={styles.inputGroup}>
                                    {shiftError && <div style={styles.error}>{shiftError}</div>}
                                    <label style={styles.label}>Day of Week</label>
                                    <select
                                        value={newShift.day_of_week}
                                        onChange={(e) => setNewShift({ ...newShift, day_of_week: e.target.value })}
                                        style={styles.input}
                                    >
                                        <option value="">Select a day</option>
                                        {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                                            <option key={day} value={day}>{day}</option>
                                        ))}
                                    </select>

                                    <label style={styles.label}>Start Time</label>
                                    <input
                                        type="time"
                                        value={newShift.shift_start_time}
                                        onChange={(e) => setNewShift({ ...newShift, shift_start_time: e.target.value })}
                                        style={styles.input}
                                    />

                                    <label style={styles.label}>End Time</label>
                                    <input
                                        type="time"
                                        value={newShift.shift_end_time}
                                        onChange={(e) => setNewShift({ ...newShift, shift_end_time: e.target.value })}
                                        style={styles.input}
                                    />

                                    <label style={styles.label}>Available Services</label>
                                    <div style={styles.serviceCheckboxes}>
                                        {services.map(service => (
                                            <label key={service.service_id} style={styles.serviceCheckbox}>
                                                <input
                                                    type="checkbox"
                                                    checked={newShift.bookable_services?.includes(service.service_id) || false}
                                                    onChange={(e) => {
                                                        const updatedServices = e.target.checked
                                                            ? [...(newShift.bookable_services || []), service.service_id]
                                                            : (newShift.bookable_services || []).filter(id => id !== service.service_id);
                                                        setNewShift({ ...newShift, bookable_services: updatedServices });
                                                    }}
                                                />
                                                {service.name}
                                            </label>
                                        ))}
                                    </div>

                                    <button onClick={() => {
                                        addNewShift();
                                        setShowBusinessHours(true);
                                    }} style={styles.button}>Save Shift</button>
                                    <button onClick={() => setShowAddShift(false)} style={styles.deleteButton}>Cancel</button>
                                </div>
                            ) : showEditShift ? (
                                <div style={styles.inputGroup}>
                                    {shiftError && <div style={styles.error}>{shiftError}</div>}
                                    <label style={styles.label}>Day of Week</label>
                                    <select
                                        value={editedShift.day_of_week}
                                        onChange={(e) => setEditedShift({ ...editedShift, day_of_week: e.target.value })}
                                        style={styles.input}
                                        disabled
                                    >
                                        <option value="">Select a day</option>
                                        {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                                            <option key={day} value={day}>{day}</option>
                                        ))}
                                    </select>

                                    <label style={styles.label}>Start Time</label>
                                    <input
                                        type="time"
                                        value={editedShift.shift_start_time}
                                        onChange={(e) => setEditedShift({ ...editedShift, shift_start_time: e.target.value })}
                                        style={styles.input}
                                    />

                                    <label style={styles.label}>End Time</label>
                                    <input
                                        type="time"
                                        value={editedShift.shift_end_time}
                                        onChange={(e) => setEditedShift({ ...editedShift, shift_end_time: e.target.value })}
                                        style={styles.input}
                                    />

                                    <label style={styles.label}>Available Services</label>
                                    <div style={styles.serviceCheckboxes}>
                                        {services.map(service => (
                                            <label key={service.service_id} style={styles.serviceCheckbox}>
                                                <input
                                                    type="checkbox"
                                                    checked={editedShift.bookable_services?.includes(service.service_id) || false}
                                                    onChange={(e) => {
                                                        const updatedServices = e.target.checked
                                                            ? [...(editedShift.bookable_services || []), service.service_id]
                                                            : (editedShift.bookable_services || []).filter(id => id !== service.service_id);
                                                        setEditedShift({ ...editedShift, bookable_services: updatedServices });
                                                    }}
                                                />
                                                {service.name}
                                            </label>
                                        ))}
                                    </div>

                                    <button onClick={editShift} style={styles.button}>Save Changes</button>
                                    <button onClick={() => {
                                        setShowEditShift(false);
                                        setEditedShift(null);
                                        setShiftError('');
                                    }} style={styles.deleteButton}>Cancel</button>
                                </div>
                            ) : (
                                <div>
                                <button onClick={() => {
                                    setNewShift({
                                        day_of_week: '',
                                        shift_start_time: '09:00',
                                        shift_end_time: '17:00',
                                        bookable_services: []
                                    });
                                    setShowAddShift(true);
                                    setShiftError('');
                                }} style={{...styles.button, marginBottom: '10px'}}>Add a Shift</button>
                                </div>
                            )}

                            {sortedBusinessHours.length > 0 && (
                                <div style={styles.shiftsList}>
                                    {sortedBusinessHours.map((shift) => (
                                        <div key={shift.id} style={styles.shiftCard}>
                                            <div style={styles.shiftHeader}>
                                                <div style={styles.shiftInfo}>
                                                    <h3 style={styles.shiftDay}>{shift.day_of_week}</h3>
                                                    <div style={styles.shiftDetails}>
                                                        <span style={styles.shiftTime}>
                                                            {formatTime(shift.shift_start_time)} - {formatTime(shift.shift_end_time)}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div style={styles.buttonContainer1}>
                                                    <button
                                                        onClick={() => {
                                                            setEditedShift({
                                                                id: shift.id,
                                                                day_of_week: shift.day_of_week,
                                                                shift_start_time: shift.shift_start_time,
                                                                shift_end_time: shift.shift_end_time,
                                                                bookable_services: shift.bookable_services || []
                                                            });
                                                            setShowEditShift(true);
                                                            setShowAddShift(false);
                                                            setShiftError('');
                                                            // Add a small delay to ensure the edit form is rendered before scrolling
                                                            setTimeout(() => {
                                                                businessHourRef.current?.scrollIntoView({ behavior: 'smooth' });
                                                            }, 100);
                                                        }}
                                                        style={styles.button}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        onClick={() => removeShift(shift.id)}
                                                        style={styles.deleteButton}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                            <div style={styles.serviceSelection}>
                                                <label>Available Services:</label>
                                                <div style={styles.serviceCheckboxes}>
                                                    {services.map(service => (
                                                        <label key={service.service_id} style={styles.serviceCheckbox}>
                                                            <input
                                                                type="checkbox"
                                                                checked={shift.bookable_services?.includes(service.service_id) || false}
                                                                onChange={(e) => handleServiceToggle(shift.id, service.service_id)}
                                                            />
                                                            {service.name}
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            </>
                            )}
                        </div>

                        <div style={styles.businessHoursSection}>
                            <h2 style={styles.sectionTitle}>Set Available Services</h2>

                            {showAddService ? (
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Service Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter service name"
                                    value={newService.name}
                                    onChange={(e) => setNewService({ ...newService, name: e.target.value })}
                                    style={styles.input}
                                />
                                <label style={styles.label}>Duration (in minutes)</label>
                                <input
                                    type="number"
                                    placeholder="Enter duration"
                                    value={newService.duration}
                                    onChange={(e) => setNewService({ ...newService, duration: e.target.value })}
                                    style={styles.input}
                                />
                                <label style={styles.label}>Capacity</label>
                                <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                    Number of customers that can be booked for this service at the same time.
                                </p>
                                <input
                                    type="number"
                                    placeholder="1"
                                    value={newService.capacity || 1}
                                    onChange={(e) => setNewService({ ...newService, capacity: e.target.value })}
                                    style={styles.input}
                                />
                                <label style={styles.label}>Description (Optional)</label>
                                <textarea
                                    placeholder="Enter service description"
                                    value={newService.description}
                                    onChange={(e) => setNewService({ ...newService, description: e.target.value })}
                                    style={styles.textarea}
                                />
                                <button onClick={() => {
                                    addService();
                                }} style={styles.button}>Save Service</button>
                                <button onClick={() => setShowAddService(false)} style={styles.deleteButton}>Cancel</button>
                            </div>
                            ) : !showEditService && (
                                <button onClick={() => {
                                    setShowAddService(true);
                                }} style={{...styles.button, marginBottom: '10px'}}>Add a Service</button>
                            )}

                            {showEditService && (
                                <div style={styles.inputGroup}>
                                    <label style={styles.label}>Service Name</label>
                                    <input
                                        type="text"
                                        placeholder={editedService.name}
                                        value={editedService.name}
                                        onChange={(e) => setEditedService({ ...editedService, name: e.target.value })}
                                        style={styles.input}
                                    />  
                                    <label style={styles.label}>Duration (in minutes)</label>
                                    <input
                                        type="number"
                                        placeholder={editedService.duration}
                                        value={editedService.duration}
                                        onChange={(e) => setEditedService({ ...editedService, duration: e.target.value })}
                                        style={styles.input}
                                    />
                                    <label style={styles.label}>Capacity</label>
                                    <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                    Number of customers that can be booked for this service at the same time.
                                    </p>
                                    <input
                                        type="number"
                                        placeholder={editedService.capacity || 1}
                                        value={editedService.capacity || 1}
                                        onChange={(e) => setEditedService({ ...editedService, capacity: e.target.value })}
                                        style={styles.input}
                                    />
                                    <label style={styles.label}>Description (Optional)</label>
                                    <textarea
                                        placeholder={editedService.description}
                                        value={editedService.description}
                                        onChange={(e) => setEditedService({ ...editedService, description: e.target.value })}
                                        style={styles.textarea}
                                    />
                                    <button onClick={editService} style={styles.button}>Save Changes</button>
                                    <button onClick={() => setShowEditService(false)} style={styles.deleteButton}>Cancel</button>
                                </div>
                            )}



                            {services.length > 0 ? (
                                <div>
                                    {services.map((service, index) => (
                                        <div key={index} style={styles.serviceCard}>
                                            <div style={styles.serviceHeader}>
                                                <div style={styles.serviceInfo}>
                                                    <h3 style={styles.serviceName}>{service.name}</h3>
                                                    <div style={styles.serviceDetails}>
                                                        <span style={styles.serviceDuration}>{service.duration} minutes</span>
                                                        <span style={styles.serviceDuration}>Capacity: {service.capacity}</span>
                                                    </div>
                                                </div>
                                                {!isMobile && (
                                            <div style={styles.buttonContainer1}>
                                                    <>
                                                        <button 
                                                            onClick={() => {
                                                                setEditedService({
                                                                    service_id: service.service_id,
                                                                    name: service.name,
                                                                    duration: service.duration,
                                                                    capacity: service.capacity,
                                                                    description: service.description
                                                                });
                                                                setShowEditService(true);
                                                                setShowAddService(false);
                                                            }}
                                                            style={styles.button}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button 
                                                            onClick={() => removeService(service.service_id)} 
                                                            style={styles.deleteButton}
                                                        >
                                                            Remove
                                                        </button>
                                                    </>
                                            </div>
                                            )}
                                            </div>
                                            {service.description && (
                                                <p style={styles.serviceDescription}>
                                                    {service.description}
                                                </p>
                                            )}
                                            {isMobile && (
                                            <div style={styles.buttonContainer}>
                                                    <>
                                                        <button 
                                                            onClick={() => {
                                                                setEditedService({
                                                                    service_id: service.service_id,
                                                                    name: service.name,
                                                                    duration: service.duration,
                                                                    capacity: service.capacity,
                                                                    description: service.description
                                                                });
                                                                setShowEditService(true);
                                                                setShowAddService(false);
                                                            }}
                                                            style={styles.button}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button 
                                                            onClick={() => removeService(service.service_id)} 
                                                            style={styles.deleteButton}
                                                        >
                                                            Remove
                                                        </button>
                                                    </>
                                            </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No services available. Add a new one!</p>
                            )}
                        </div>

                        <div style={styles.businessHoursSection}>
                            <h2>Configure Your Booking Options</h2>

                            <div style={styles.inputGroup}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ ...styles.label, marginRight: '5px' }}>Allow Auto-Confirmation</label>
                                    <input 
                                        type="checkbox" 
                                        checked={auto_confirm} 
                                        onChange={(e) => {
                                            setAuto_confirm(e.target.checked);
                                            saveBookingOptions(e.target.checked, notifyOwner, notifyCustomer, bookableDays, bookingInterval, hoursAdvance, reqCusInfo);
                                        }}
                                        style={{ width: '40px', height: '20px', marginTop: '-2px' }}
                                    />
                                    {!auto_confirm && <label style={{marginLeft: '0px', fontSize: '12px', color: '#555', marginTop: '-3px'}}>Check to enable</label>}
                                </div>
                                <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                    All valid service requests will be accepted automatically without your manual approval. 
                                    <br />
                                    To enable instant confirmation, please maintain an accurate calendar.
                                </p>
                            </div>

                            <div style={styles.inputGroup}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{...styles.label, marginRight: '5px'}}>Send Reminders to me</label>
                                    <input 
                                        type="checkbox" 
                                        checked={notifyOwner} 
                                        onChange={(e) => {
                                            setNotifyOwner(e.target.checked);
                                            saveBookingOptions(auto_confirm, e.target.checked, notifyCustomer, bookableDays, bookingInterval, hoursAdvance, reqCusInfo);
                                        }}
                                        style={{ width: '40px', height: '20px', marginTop: '-2px' }}
                                    />
                                    {!notifyOwner && <label style={{marginLeft: '0px', fontSize: '12px', color: '#555', marginTop: '-3px'}}>Check to enable</label>}
                                </div>
                                <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                    You will receive email reminders 24 hours and 2 hours before the event.
                                </p>
                            </div>

                            <div style={styles.inputGroup}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{...styles.label, marginRight: '5px'}}>Send Reminders to customers</label>
                                    <input 
                                        type="checkbox" 
                                        checked={notifyCustomer} 
                                        onChange={(e) => {
                                            setNotifyCustomer(e.target.checked);
                                            saveBookingOptions(auto_confirm, notifyOwner, e.target.checked, bookableDays, bookingInterval, hoursAdvance, reqCusInfo);
                                        }}
                                        style={{ width: '40px', height: '20px', marginTop: '-2px' }}
                                    />
                                    {!notifyCustomer && <label style={{marginLeft: '0px', fontSize: '12px', color: '#555', marginTop: '-3px'}}>Check to enable</label>}
                                </div>
                                <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                    Your customers will receive email reminders 24 hours and 2 hours before the event.
                                    <br />
                                    Only customers with a valid email address will receive reminders.
                                </p>
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Show availability for the next</label>
                                <select
                                    value={bookableDays}
                                    onChange={(e) => {
                                        setBookableDays(Number(e.target.value));
                                        saveBookingOptions(auto_confirm, notifyOwner, notifyCustomer, Number(e.target.value), bookingInterval, hoursAdvance, reqCusInfo);
                                    }}
                                    style={styles.input}
                                >
                                    {[...Array(90)].map((_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            {i + 1} days
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Accept available slots start at what time of an hour? 
                                </label>
                                <p style={{ fontSize: '12px', color: '#555', marginTop: '0px' }}>
                                    For example:
                                    <br />(15 min) 9:00, 9:15, 9:30, 9:45
                                    <br />(30 min) 9:00, 9:30
                                    <br />(60 min) 9:00
                                </p>
                                <select
                                    value={bookingInterval}
                                    onChange={(e) => {
                                        setBookingInterval(Number(e.target.value));
                                        saveBookingOptions(auto_confirm, notifyOwner, notifyCustomer, bookableDays, Number(e.target.value), hoursAdvance, reqCusInfo);
                                    }}
                                    style={styles.input}
                                >
                                    <option value={15}>15 minutes</option>
                                    <option value={30}>30 minutes</option>
                                    <option value={60}>60 minutes</option>
                                </select>
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Customer must book at least</label>
                                <select
                                    value={hoursAdvance}
                                    onChange={(e) => {
                                        setHoursAdvance(Number(e.target.value));
                                        saveBookingOptions(auto_confirm, notifyOwner, notifyCustomer, bookableDays, bookingInterval, Number(e.target.value), reqCusInfo);
                                    }}
                                    style={styles.input}
                                >
                                    {[...Array(49)].map((_, i) => (
                                        <option key={i} value={i}>
                                            {i} hours in advance
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <label style={styles.label}>Required customer Information</label>
                            <div>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={reqCusInfo.name}
                                        onChange={(e) => {
                                            setReqCusInfo({ ...reqCusInfo, name: e.target.checked });
                                            saveBookingOptions(auto_confirm, notifyOwner, notifyCustomer, bookableDays, bookingInterval, hoursAdvance, { ...reqCusInfo, name: e.target.checked });
                                        }}
                                    />
                                    Name
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="checkbox" checked={true} disabled /> Email (Always Required)
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={reqCusInfo.phone}
                                        onChange={(e) => {
                                            setReqCusInfo({ ...reqCusInfo, phone: e.target.checked });
                                            saveBookingOptions(auto_confirm, notifyOwner, notifyCustomer, bookableDays, bookingInterval, hoursAdvance, { ...reqCusInfo, phone: e.target.checked });
                                        }}
                                    />
                                    Phone
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={reqCusInfo.address}
                                        onChange={(e) => {
                                            setReqCusInfo({ ...reqCusInfo, address: e.target.checked });
                                            saveBookingOptions(auto_confirm, notifyOwner, notifyCustomer, bookableDays, bookingInterval, hoursAdvance, { ...reqCusInfo, address: e.target.checked });
                                        }}
                                    />
                                    Address
                                </label>
                            </div>
                        </div>
                        
                        
                        <div style={styles.businessHoursSection}>
                            <h2>Publish Your Business Page</h2>

                            {!profile.business_id && <div style={styles.inputGroup}>
                                <label style={styles.label}>Business ID</label>
                                <p style={{ fontSize: "14px", color: "#555" }}>
                                    This will be added to your public page URL. 
                                    <br />For example: www.rili.day/michelle
                                    <br />Pick something simple and related to your business. Only letters and numbers are allowed. 
                                    <br />⚠️ You are not allowed to change it once saved.
                                </p>
                                <input
                                    type="text"
                                    placeholder="Enter a unique ID (e.g., michelle)"
                                    value={tempBusinessId} // Use temp state
                                    onChange={(e) => {
                                        const value = e.target.value.toLowerCase().replace(/[^a-z0-9]/g, ""); // Only letters & numbers
                                        setTempBusinessId(value); // Update temp state
                                    }}
                                    style={styles.input}
                                />
                                <button 
                                    onClick={async () => {
                                        if (!tempBusinessId.trim()) {
                                            alert("Business ID cannot be empty.");
                                            return;
                                        }

                                        const updatedProfile = { ...profile, business_id: tempBusinessId }; // Use tempBusinessId
                                        setProfile(updatedProfile); // Update UI immediately
                                        
                                        try {
                                            await axios.post(`${CONFIG.BACKEND_URL}/api/profile`, updatedProfile);
                                            alert("Business ID saved successfully!");
                                        } catch (err) {
                                            fetchProfile();
                                            if (err.response && err.response.status === 400) {
                                                alert(`Failed to save Business ID: ${err.response.data.error}`);
                                            } else {
                                                alert("Failed to save Business ID. Please try again.");
                                            }
                                        }
                                    }} 
                                    style={styles.button}
                                >
                                    Save Business ID
                                </button>
                            </div>}

                            {profile.business_id && profile.name && services.length > 0 ? (
                                <>
                                    {published ? (
                                        <>
                                            <p style={{ color: "green", fontWeight: "bold" }}>✅ Your page is published!</p>
                                            <p>Your public page is:  <br />
                                                <a href={`/${profile.business_id}`} target="_blank" rel="noopener noreferrer">
                                                    {window.location.origin}/{profile.business_id}
                                                </a>
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                        <p style={{ color: "red", fontWeight: "bold" }}>⚠️ Your page is not published yet.</p>
                                        <p>Once published, your public page will be available at:  <br />
                                                <a>
                                                    {window.location.origin}/{profile.business_id}
                                                </a>
                                            </p>
                                        </>
                                    )}

                                    <button onClick={togglePublishStatus} style={published ? styles.button : styles.button}>
                                        {published ? "Unpublish Page" : "Publish Page"}
                                    </button>
                                </>
                            ) : (
                                <p style={{ color: "red", fontWeight: "bold" }}>⚠️ Business ID, Business Name and at least one Service are required before publishing your page.</p>
                            )}
                        </div>
                    </TabsContent>
                </Tabs>

                {/* Bottom Section */}
                
                <div style={styles.bottomSection}>
                        <button onClick={() => setShowChangePassword(!showChangePassword)} style={styles.passwordButton}>
                            {showChangePassword ? "Cancel" : "Change Password"}
                        </button>
                        <button onClick={handleLogout} style={styles.logoutButton}>
                        Logout
                        </button>                
                </div>
                {showChangePassword && (
                            <div style={styles.inputGroup}>
                                <input
                                    type="password"
                                    placeholder="Current Password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    style={styles.input}
                                />
                                <input
                                    type="password"
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    style={styles.input}
                                />
                                <input
                                    type="password"
                                    placeholder="Confirm New Password"
                                    value={confirmNewPassword}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                    style={styles.input}
                                />
                                <button onClick={handleChangePassword} style={styles.bpasswordButton}>Update Password</button>
                                {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
                            </div>
                )}
                <p>Logged in as: {userEmail}</p>
                <p>Business Timezone: {profile.timezone}</p>

            </div>

            <div style={styles.footer}>
        <p>
          <a href={`${CONFIG.FRONTEND_URL}/privacy`}>Privacy Policy</a>
          {" "}|{" "}
          <a href={`${CONFIG.FRONTEND_URL}/terms`}>Terms of Service</a>
        </p>
      </div>
        </div>
    );
};

const styles = {
    label: { display: "block", marginBottom: "5px", fontWeight: "bold", marginTop: "10px" },
    container: {
        position: "relative",
        padding: "20px",
        paddingTop: "0px",
        maxWidth: "800px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
    },
    accountSection: {
        position: "absolute",
        zIndex: 1000,
        right: "20px",
        marginTop: "-30px",
        maxWidth: "240px",
        padding: "5px 20px 10px 20px",
        borderRadius: "8px",
        backgroundColor: "#e0e0e0",
        marginBottom: "20px",
        fontSize: "11px",
        textAlign: "left",
    },
    bottomSection: { 
        marginBottom: "20px", 
        marginTop: "100px",
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "left",
        flexWrap: "wrap",
        alignItems: "flex-start",
    },
    topSection: { 
        display: "flex", 
        justifyContent: "space-between", 
        paddingBottom: "20px",
        paddingTop: "10px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.6",
    },
    logo: {
        fontFamily: "Verdana, sans-serif", // Ensures a sans-serif fallback
        fontWeight: "bold", // Makes the text bold
        fontSize: "24px", // Adjust size as needed
        color: "#2c3e50", // Adjust color as needed
        margin: "0px",
    },
    button: {
        padding: "10px 20px",
        backgroundColor: "#2c3e50",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        marginTop: "10px",
        marginRight: "10px",
        transition: "background-color 0.3s ease",
    },
    passwordButton: {
        padding: "10px 20px",
        backgroundColor: "grey",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        marginTop: "10px",
        transition: "background-color 0.3s ease",
    },
    logoutButton: {
        padding: "10px 20px",
        backgroundColor: "#dc3545",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        marginTop: "10px",
        transition: "background-color 0.3s ease",
    },
    passwordSection: { 
        display: "flex", 
        flexDirection: "column", 
        gap: "10px" 
    },
    colorBlock: {
        display: "inline-block",
        width: "40px",
        height: "15px", 
        backgroundColor: "rgba(17, 129, 0, 0.338)",
        borderRadius: "3px",
        border: "",
        margin: "0 5px"
    },
    title: {
        fontSize: "32px",
        textAlign: "center",
        marginBottom: "30px",
    },
    email: {
        fontSize: "16px",
        textAlign: "center",
        marginBottom: "20px",
        color: "#555",
    },
    error: {
        color: '#dc3545',
        backgroundColor: '#f8d7da',
        border: '1px solid #f5c6cb',
        borderRadius: '4px',
        padding: '10px',
        marginBottom: '15px',
        fontSize: '14px'
    },
    success: { 
        color: "green", 
        marginTop: "10px" 
    },
    profileSection: {
        marginTop: "0px",
        marginBottom: "30px",
        padding: "20px",
        borderRadius: "0px",
        backgroundColor: "#f9f9f9",
    },
    sectionTitle: {
        fontSize: "24px",
        marginBottom: "15px",
    },
    inputGroup: {
        marginBottom: "20px",
        backgroundColor: "#f9f9f9",
    },
    dayCheckboxCol: {
        width: "20%",
        position: "relative",
        top: "0",
    },   
    input: {
        width: "80%",
        padding: "10px",
        borderRadius: "5px",
        border: "0px solid #ccc",
        fontSize: "16px",
        display: "block",
        marginTop: "5px",
    },
    textarea: {
        width: "80%",
        padding: "10px",
        borderRadius: "5px",
        border: "0px solid #ccc",
        fontSize: "16px",
        height: "80px",
        marginTop: "5px",
        display: "block",
    },
    buttonHover: {
        backgroundColor: "#0056b3",
    },
    calendarActions: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
        gap: "15px",
    },
    changePasswordSection: {
        marginTop: "30px",
        padding: "20px",
        borderRadius: "8px",
        display: "block",  // Ensures it takes up the full width
        width: "100%",  // Makes it span the entire width of the container
        clear: "both",  // Forces it to move below floated elements (if any)
    },    
    calendarSection: {
        textAlign: "left",
        marginTop: "0px",
        marginBottom: "10px",
        paddingBottom: "20px",
        paddingTop: "20px",
        paddingLeft: "0px",
        paddingRight: "0px",
        //border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
    },
    calendarSection2: {
        textAlign: "left",
        marginTop: "-10px",
        marginBottom: "10px",
        paddingBottom: "20px",
        paddingTop: "20px",
        paddingLeft: "0px",
        paddingRight: "0px",
        //border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
        marginLeft: "-20px",
        marginRight: "-20px",
    },
    calendar: {
        maxWidth: "90%",
        margin: "0 auto",
    },
    workingHoursSection: {
        marginTop: "30px",
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
    },
    workingHoursRow: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        marginBottom: "15px",
        justifyContent: "space-between",
        gap: "10px",
    },
    shiftGroup: {
        width: "30%",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        flex: "1",
    },
    timeInput: {
        width : "auto",
        fontSize: "16px",
        borderRadius: "5px",
        border: "0px solid #ccc",
    },
    servicesSection: {
        marginTop: "30px",
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
    },
    servicesList: {
        marginTop: "20px",
        padding: "10px",
        backgroundColor: "#fff",
        borderRadius: "5px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    },
    serviceItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "10px",
    },
    requestsSection: { marginTop: "30px", padding: "20px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" },
    requestItem: {
        marginBottom: "20px",
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    },
    deleteButton: {
        padding: "10px 20px",
        backgroundColor: "#dc3545",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        marginTop: "10px",
        transition: "background-color 0.3s ease",
    },
    deleteButtonHover: {
        backgroundColor: "#a71d2a",
    },
    acceptButton: { marginRight: "10px", backgroundColor: "#28a745", color: "#fff", padding: "5px 10px", border: "none", borderRadius: "5px", cursor: "pointer",margin: "10px 5px 0 0", },
    declineButton: { backgroundColor: "#dc3545", color: "#fff", padding: "5px 10px", border: "none", borderRadius: "5px", cursor: "pointer", margin: "10px 0 0 0", },
    footer: {
        marginTop: "50px",
        padding: "0px",
        backgroundColor: "rgb(226, 218, 195)",
        textAlign: "center",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
        height: "40px"
    },
    serviceCard: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '15px',
        marginBottom: '15px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
        }
    },
    serviceHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
    },
    serviceInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    serviceDetails: {
        display: 'flex',
        gap: '10px',
    },
    serviceName: {
        margin: 0,
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#2c3e50',
    },
    serviceDuration: {
        fontSize: '14px',
        color: '#666',
        backgroundColor: '#f0f0f0',
        padding: '2px 8px',
        borderRadius: '12px',
    },
    serviceDescription: {
        margin: 0,
        fontSize: '14px',
        color: '#555',
        lineHeight: '1.5',
    },
    buttonContainer: {
        display: 'flex',
        gap: '10px',
    },
    buttonContainer1: {
        display: 'flex',
        gap: '10px',
    },
    daySection: {
        marginBottom: '20px',
        padding: '15px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
    },
    dayTitle: {
        margin: '0 0 10px 0',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    shiftsList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    shiftCard: {
        padding: '15px',
        backgroundColor: 'white',
        borderRadius: '6px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    shiftTime: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '10px',
    },
    serviceSelection: {
        marginTop: '10px',
    },
    serviceCheckboxes: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '5px',
    },
    serviceCheckbox: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: '14px',
    },
    businessHoursSection: {
        marginTop: '30px',
        padding: '20px',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
    },
    shiftHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
    },
    shiftInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    shiftDetails: {
        display: 'flex',
        gap: '10px',
    },
    shiftDay: {
        margin: 0,
        fontSize: '16px',
        fontWeight: 'bold',
    },
};

export default Dashboard;